import { Icon, Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import SkModal from "components/SkModal";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import ChatComponent from "./Options/ChatComponent";
import Form from "./Options/Form";
import { useLocation } from "react-router-dom";

const SupportChat = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { state } = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenCreate = () => {
    setSelectedItem(null);
    setIsOpenUpdate(false);
    setIsOpen(true);
  };

  const handleOpenEdit = (item) => {
    setSelectedItem(item);
    setIsOpenUpdate(true);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsOpenUpdate(false);
    setSelectedItem(null);
  };

  const handleSuccess = () => {
    handleClose();
    setRefreshKey((k) => k + 1);
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <Card overflowY="hidden">
            {/* Gradient Header */}
            <MDBox
              mx={2}
              mt={-3}
              py={1}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                Help &amp; Support
              </MDTypography>

              <MDButton
                variant="gradient"
                color="dark"
                sx={({ palette: { dark, white } }) => ({
                  color: white.main,
                  backgroundColor: dark.main,
                  "&:hover": {
                    color: white.main,
                    backgroundColor: dark.main,
                  },
                })}
                onClick={handleOpenCreate}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp; Create
              </MDButton>
            </MDBox>

            {/* Table */}
            <MDBox mx={2} my={2.5} py={1} px={2} borderRadius="lg" coloredShadow="info">
              <ChatComponent
                refreshKey={refreshKey}
                onEdit={handleOpenEdit}
              />
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>

      {/* Create / Edit Modal */}
      <SkModal
        show={isOpen}
        unShow={handleClose}
        width={{ sx: "100%", md: "45%", xl: "45%", sm: "100%" }}
        height={"auto"}
        padding={2}
        overflowY={true}
      >
        {isOpen && (
          <Form
            setIsOpen={handleClose}
            onSuccess={handleSuccess}
            isOpenUpdate={isOpenUpdate}
            singleData={selectedItem}
          />
        )}
      </SkModal>
    </>
  );
};

export default SupportChat;
